import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TaskDetailsRoutingModule} from './task-details-routing.module';
import {TaskClaimedComponent, TaskCompletedComponent, TaskDetailsComponent} from './task-details.component';
import {InvoicesTableComponent} from './components/invoices-table/invoices-table.component';
import {TranslateModule} from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ReactiveFormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {TaskFilterDialogComponent} from './components/filter-dialog/filter-dialog.component';

@NgModule({
    declarations: [
        TaskDetailsComponent,
        InvoicesTableComponent,
        TaskCompletedComponent,
        TaskClaimedComponent,
        TaskFilterDialogComponent
    ],
    imports: [
        CommonModule,
        TaskDetailsRoutingModule,
        /* Angular material */
        MatButtonModule,
        MatIconModule,
        MatGridListModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatTabsModule,
        MatDialogModule,
        TranslateModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatDatepickerModule,
        MatInputModule
    ]
})
export class TaskDetailsModule {
}
